<div class="input-group" [formGroup]="formGroup">
  <div *ngIf="label">
    {{ label }}
  </div>
  <div class="modifier-input-group">
    <mat-form-field appearance="outline" style="width: 80px" *ngIf="fontSizeFormControlName">
      <mat-label floatLabel="always">Size</mat-label>
      <input matInput [formControlName]="fontSizeFormControlName" type="number" />
    </mat-form-field>
    <ng-container *ngIf="fontColorFormControlName">
      <lib-color-picker-square
        *ngIf="compactColorPicker; else defaultColorPicker"
        [formGroup]="formGroup"
        [controlName]="fontColorFormControlName"
        [ariaLabel]="(label || 'Text') + ' colour'"
      ></lib-color-picker-square>

      <ng-template #defaultColorPicker>
        <mat-form-field appearance="outline" class="color-input" style="width: 60px">
          <mat-label floatLabel="always">Color</mat-label>
          <input
            type="color"
            matInput
            [formControlName]="fontColorFormControlName"
            style="width: 25px; height: 27px"
          />
        </mat-form-field>
      </ng-template>
    </ng-container>
  </div>
  <div class="input-group text-input-group" [class.full-width]="fullWidth">
    <mat-form-field appearance="outline" [class.full-width]="fullWidth">
      <mat-label>Text</mat-label>
      <textarea *ngIf="multiline; else singleLineInput" matInput [formControlName]="textFormControlName"></textarea>
      <ng-template #singleLineInput>
        <input matInput [formControlName]="textFormControlName" />
      </ng-template>
      <mat-hint *ngIf="textHint">{{ textHint }}</mat-hint>
    </mat-form-field>
  </div>
</div>
